var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9997 0.833252C46.108 0.833252 59.1663 13.8916 59.1663 29.9999C59.1663 46.1082 46.108 59.1666 29.9997 59.1666C13.8914 59.1666 0.833008 46.1082 0.833008 29.9999C0.833008 13.8916 13.8914 0.833252 29.9997 0.833252ZM29.9997 6.66659C17.113 6.66659 6.66634 17.1133 6.66634 29.9999C6.66634 42.8866 17.113 53.3333 29.9997 53.3333C42.8863 53.3333 53.333 42.8866 53.333 29.9999C53.333 17.1133 42.8863 6.66659 29.9997 6.66659ZM39.604 19.1875C40.743 18.0485 42.5897 18.0485 43.7287 19.1875C44.8678 20.3266 44.8678 22.1733 43.7287 23.3123L26.2287 40.8123C25.0897 41.9513 23.243 41.9513 22.1039 40.8123L16.2706 34.979C15.1316 33.84 15.1316 31.9932 16.2706 30.8542C17.4096 29.7152 19.2564 29.7152 20.3954 30.8542L24.1663 34.6251L39.604 19.1875Z",
    fill: "#3FC078"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.307207c654dcfd5475da4801660f45fc.svg";
export { ForwardRef as ReactComponent };